import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "prev",
  "use": "prev-usage",
  "viewBox": "0 0 12 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 21\" id=\"prev\"><path d=\"M11 20l-9-9.5L11 1\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol